import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

const MIN_REASON = 10;

// Modal that gates "log in as" with a typed reason. The reason is required
// (>= 10 chars) and recorded in the impersonation_session audit row.
const LogInAsModal = ({ show, target, onCancel, onConfirm }) => {
    const [reason, setReason] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (reason.trim().length < MIN_REASON) {
            setError(`Please provide at least ${MIN_REASON} characters of context.`);
            return;
        }
        setSubmitting(true);
        setError(null);
        try {
            await onConfirm(reason.trim());
        } catch (err) {
            setError(err.message || "Could not start impersonation.");
            setSubmitting(false);
        }
    };

    const handleHide = () => {
        if (submitting) return;
        setReason("");
        setError(null);
        onCancel();
    };

    return (
        <Modal show={show} onHide={handleHide} backdrop="static" centered>
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton={!submitting}>
                    <Modal.Title>Log in as {target?.ownerEmail || "user"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-muted small">
                        Every action will attribute to this user. Your admin identity
                        is recorded in the audit log along with the reason below.
                    </p>
                    <Form.Group>
                        <Form.Label>Reason</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="e.g., reproducing a bug reported in support ticket #1234"
                            autoFocus
                            disabled={submitting}
                        />
                        <Form.Text className="text-muted">
                            Minimum {MIN_REASON} characters.
                        </Form.Text>
                    </Form.Group>
                    {error && <div className="text-danger mt-3">{error}</div>}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={handleHide} disabled={submitting}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="danger" disabled={submitting}>
                        {submitting ? "Starting..." : "Log in as user"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default LogInAsModal;
